import { z } from 'zod';

export const getTrendingsSchema = z.object({
	count: z.number(),
	articles: z.array(
		z.object({
			title: z.string(),
			name: z.string(),
			url: z.string(),
			views: z.number().optional(),
		})
	),
});
